

import Color from 'color';
export default class DPColors {
	constructor(config) {
		if (config.dpDebugEn) console.log('AdminThemeColors');
	}
	// contrast range: 1 - 21
	static getContrastColor(srcColor, resColorsPossibilities = ['#fff', '#484848'], fallBackContrastThreshold = 3, resColorsFallback = ['#292929']) {
		const contrasts = [];
		resColorsPossibilities.forEach((color) => {
			const colorObj = Color(color);
			contrasts.push({ color: colorObj, contrast: Color(srcColor).contrast(colorObj) });
		});
		contrasts.sort((a, b) => b.contrast - a.contrast);
		//console.log(contrasts.map((element) => element.contrast));
		if (contrasts.length) {

			if (contrasts[0].contrast < fallBackContrastThreshold) {
				resColorsFallback.forEach((color) => {
					const colorObj = Color(color);
					contrasts.push({ color: colorObj, contrast: Color(srcColor).contrast(colorObj) });
				});
				contrasts.sort((a, b) => b.contrast - a.contrast);
			}
			return contrasts[0].color;

		}
		return resColorsPossibilities[0] ? Color(resColorsPossibilities[0]) : (resColorsFallback[0] ? Color(resColorsFallback[0]) : Color('#fff'));
	}

	static getMostColor(srcColorsObj, rgbIdx /*r = red*, g = green, b = blue*/) {
		let res = null;
		if (srcColorsObj) {
			const colorsObj = [...srcColorsObj];
			colorsObj.sort((a, b) => DPColors.compareColorsByRgbHue(rgbIdx, a, b));
			res = colorsObj[0];
		}
		return res;
	}

	static getRgbHueFeature = (rgbIdx, color) => {
		switch (rgbIdx) {
			case 'r': return color.red() + (color.red() - color.green()) + (color.red() - color.blue());
			case 'g': return color.green() + (color.green() - color.red()) + (color.green() - color.blue());
			case 'b': return color.blue() + (color.blue() - color.red()) + (color.blue() - color.green());
		}
	}

	static compareColorsByRgbHue = (rgbIdx, a, b) => {
		return DPColors.getRgbHueFeature(rgbIdx, b) - DPColors.getRgbHueFeature(rgbIdx, a);
	}
}